import React from "react";

const PrivacyAugUpdated = () => {
  return (
    <div className="privacy-policy-page">
      {/* <h1 align="center" className="heading-title">Mahakumbh Mela Festive</h1> */}
      <h3 align="center" className="page-title">
        PRIVACY POLICY
      </h3>
      <p className="page-sub-title privacy-sub-title">
        Welcome to the Coca-Cola Consumer Privacy Policy
      </p>
      <div>
        <p style={{marginTop:"1rem"}}>
          The Coca-Cola Company and its affiliates (together, Coca-Cola or we)
          take your right to privacy seriously. We appreciate that you trust us
          with your personal information and respecting your privacy is at the
          core of our interactions with you.
        </p>
      </div>
      <div>
        <p  style={{marginTop:"1rem"}}>
          Coca-Cola’s handling of personal information is guided by these
          principles:
        </p>
        <div style={{ marginLeft: "1rem" }}>
          <p>. Transparency</p>
          <p>. Respect</p>
          <p>. Trust</p>
          <p>. Fairness</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Effective Date: 12.12.2024</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            The Coca-Cola Consumer Privacy Policy (Privacy Policy) describes the
            personal information that Coca-Cola collects from or about users of
            the websites, mobile applications (Apps), widgets and other online
            and offline services that Coca-Cola operates (together, the
            Services) and how we use and protect that personal information. This
            Privacy Policy also explains how users can make choices about their
            personal information.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            When we refer to personal information (sometimes referred to as
            personal data under some laws) in this Privacy Policy, we mean
            information that identifies or can be used to identify an individual
            human being. This means that personal information includes direct
            identifiers (such as name) and indirect identifiers (such as
            computer or mobile device ID and IP address). When we refer to you
            or user, we mean someone who uses any of the Services. When we refer
            to controller, we mean the person or entity that determines what
            personal information is collected from or about you and how that
            personal information is used and protected.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            How we collect, use and protect your personal information is subject
            to the laws in the places in which we operate. This means that we
            may have different practices in different places. For more
            information, please see Privacy Rights and Choices, which includes
            additional descriptions of your rights and our obligations in
            certain key jurisdictions and who to contact.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            IF YOU HAVE QUESTIONS ABOUT HOW COCA-COLA PROCESSES YOUR PERSONAL
            INFORMATION, PLEASE CONTACT PRIVACY@COCA-COLA.COM.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>WHAT’S IN THIS PRIVACY POLICY?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>This Privacy Policy is divided into the following sections:</p>
        </div>
        <div style={{ marginLeft: "2.3rem" }}>
          <ol>
            <li style={{textDecoration:"underLine"}}>WHEN DOES THIS PRIVACY POLICY APPLY?</li>
            <li style={{textDecoration:"underLine"}}>WHERE DOES THIS PRIVACY POLICY APPLY?</li>
            <li style={{textDecoration:"underLine"}}>
              WHAT TYPES OF PERSONAL INFORMATION DOES COCA-COLA COLLECT AND WHY?
            </li>
            <li style={{textDecoration:"underLine"}}>HOW DOES COCA-COLA USE PERSONAL INFORMATION?</li>
            <li style={{textDecoration:"underLine"}}>DOES COCA-COLA USE COOKIES?</li>
            <li style={{textDecoration:"underLine"}}>HOW DOES COCA-COLA SHARE PERSONAL INFORMATION?</li>
            <li style={{textDecoration:"underLine"}}>HOW DOES COCA-COLA PROTECT PERSONAL INFORMATION?</li>
            <li style={{textDecoration:"underLine"}}>HOW LONG DOES COCA-COLA RETAIN PERSONAL INFORMATION?</li>
            <li style={{textDecoration:"underLine"}}>WHAT CHOICES ARE AVAILABLE FOR PERSONAL INFORMATION?</li>
            <li style={{textDecoration:"underLine"}}>HOW DOES COCA-COLA PROTECT CHILDREN''S PRIVACY?</li>
            <li style={{textDecoration:"underLine"}}>
              DOES COCA-COLA TRANSFER PERSONAL INFORMATION TO OTHER COUNTRIES?
            </li>
            <li style={{textDecoration:"underLine"}}>WHEN IS THIS PRIVACY POLICY CHANGED?</li>
            <li style={{textDecoration:"underLine"}}>PRIVACY RIGHTS AND CHOICES</li>
          </ol>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>2. WHEN DOES THIS PRIVACY POLICY APPLY?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            This Privacy Policy was posted and is effective for new users on
            12.12.2024.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            The prior versions of Coca-Cola’s privacy policies apply until
            22.12.2024 and are available upon request to privacy@coca-cola.com.
          </p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>WHERE DOES THIS PRIVACY POLICY APPLY?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            The Privacy Policy applies to the personal information collected
            from users of the Services in which the Privacy Policy is posted or
            linked, when the Privacy Policy is specifically referenced in the
            Services or when Coca-Cola asks you to acknowledge it. This Privacy
            Policy also covers personal information that we collect from
            consumers who contact us by email, telephone and offline, such as
            during an in-person event.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>
            WHAT TYPES OF PERSONAL INFORMATION DOES COCA-COLA COLLECT AND WHY?
          </p>
          <p style={{textDecoration:"underLine"}}>Information you choose to give us</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            We collect the personal information you choose to share with us.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p style={{textDecoration:"underLine"}}>1. Information about use of our Apps</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            When you download and install one of our Apps, the information that
            we collect depends on your mobile device’s operating system and
            permissions. Our Apps need to use certain features and data from
            your mobile device in order to function. For example, if you want a
            seamless online to App experience we need to collect and link
            information from your web browser.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            To learn more about the specific information collected by an App,
            please check your device settings or review the permissions
            information available on the particular platform (e.g., Google Play
            and the App Store) from which you downloaded the App. Certain Apps
            also allow you to check or change your status for certain data
            collection in the App settings. If you change your settings, certain
            App features may not function properly.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            To stop collection of all information through an App, please
            uninstall the App.
          </p>
          <p style={{ marginLeft: "1rem" }}>
            Information automatically collected during use of the Services
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            We automatically collect certain information from and about use of
            the Services from users’ computers and mobile devices. Some
            automatically-collected information is personal information under
            certain laws. This information is automatically collected using
            cookies, pixel, web beacons and similar data collection technology
            (collectively, data collection technology).
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>1. Information collected from third parties</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            From time to time, we receive personal information from third
            parties that we use to learn more about our users, personalize user
            experience and more effectively promote and improve the Services.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>1. Other information collected with your consent</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            We may ask you for your consent to collect specific types of
            personal information so that you can participate in new activities,
            receive exclusive content or test new features. Under some privacy
            laws, Coca-Cola is required to obtain consent before collecting and
            using personal information. Please see Section 9 for details.
          </p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>4. HOW DOES COCA-COLA USE PERSONAL INFORMATION?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            Coca-Cola uses personal information to provide and improve the
            Services, manage our business, protect users and enforce our legal
            rights.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>
            5. DOES COCA-COLA USE COOKIES AND OTHER DATA COLLECTION TECHNOLOGY?
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            We use cookies and other data collection technology to recognize you
            and/or your device(s) when you use the Services and collect personal
            information about you.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            In some rare cases, there may be some websites that are part of the
            Services which have specific notices about cookies and other data
            collection technology that apply to specific websites and consumers.
            If you visit a Coca-Cola website with a notice about cookies, then
            that website’s cookie notice applies.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>6. HOW DOES COCA-COLA SHARE PERSONAL INFORMATION?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            Coca-Cola shares personal information with people and businesses
            that help operate the Services and carry out our business and when
            we are legally permitted or required to do so. We also share
            personal information when a user requests that we share it. We
            require that recipients of personal information from us comply with
            this Privacy Policy unless and until users are made aware that a
            different privacy policy or notice will apply.
          </p>
        </div>

        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>7. HOW DOES COCA-COLA PROTECT PERSONAL INFORMATION?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            Coca-Cola takes care to secure and safeguard the personal
            information entrusted to us. We use a variety of measures to help us
            protect personal information from unauthorized access and use.
          </p>
        </div>

        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>8. HOW LONG DOES COCA-COLA RETAIN PERSONAL INFORMATION?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            We retain personal information about a user for as long as user’s
            account is active and otherwise as long as necessary for the
            purposes described above. We also retain personal information as
            long as necessary to comply with legal obligations, resolve
            disputes, and enforce our agreements.
          </p>
        </div>

        <div>
          <p  style={{marginTop:"1rem"}}>Learn More</p>
        </div>
        <div style={{ marginLeft: "1.2rem" }}>
          <p  style={{marginTop:"1rem"}}>9. WHAT CHOICES ARE AVAILABLE FOR PERSONAL INFORMATION?</p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            You can make choices about Coca-Cola’s handling of your personal
            information. You can exercise your privacy rights by contacting
            Coca-Cola as described in this Section 9 or using various tools
            available through your browser or that Coca-Cola makes available. In
            some cases, your ability to access or control your personal
            information is limited by applicable law.
          </p>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>Mobile Device Preferences</p>
          <p  style={{marginTop:"1rem"}}>
            Mobile operating systems and app platforms (e.g., Google Play, App
            Store) have permission settings for specific types of mobile device
            data and notifications, such as for access to contacts, geo-location
            services and push notifications. You can use the settings on your
            mobile device to consent to or deny certain information collection
            and/or push notifications. Certain Apps also may have settings that
            allow you to change permissions and push notifications. For some
            Apps, changing settings may cause certain aspects of the App to not
            functional properly.
          </p>
          <p  style={{marginTop:"1rem"}}>
            You can stop all information collection from an App by uninstalling
            the App. If you uninstall the App, please also consider checking
            your operating system’s settings to confirm that the unique
            identifier and other activity associated with your use of the App is
            deleted from your mobile device.
          </p>
          <p  style={{marginTop:"1rem"}}>Opting out of Coca-Cola’s Emails and Text Messages</p>
          <p  style={{marginTop:"1rem"}}>
            To stop receiving promotional emails from Coca-Cola, please click
            the “Unsubscribe” link at the bottom of the email. After you opt
            out, we may still send you non-promotional communications, such as
            receipts for purchases or administrative information about your
            account.
          </p>
          <p  style={{marginTop:"1rem"}}>
            Your account settings also may allow you to change your notification
            preferences, such as push notifications from an App.
          </p>
          <p  style={{marginTop:"1rem"}}>
            To stop receiving promotional text messages (SMS or MMS), please
            send a reply text message indicating that you wish to stop receiving
            promotional text messages from us – such as by testing the word
            “Stop”. You also may let us know as directed below in the
            “Contacting Us” section. Please specify which types of
            communications you no longer wish to receive together with the
            relevant telephone number, address, and/or e-mail address. If you do
            opt-out of receiving marketing-related messages from us, we may
            still send you important administrative messages, such as emails
            about your accounts or purchases.
          </p>
          <p  style={{marginTop:"1rem"}}>
            INFORMATION ABOUT PRIVACY RIGHTS AND CHOICES FOR SPECIFIC
            JURISDICTIONS IS PROVIDED IN SECTION 13 AT THE END OF THIS PRIVACY
            POLICY. WE ENCOURAGE YOU TO REVIEW THE RELEVANT SECTIONS.
          </p>
          <p  style={{marginTop:"1rem"}}>
            IF YOU ARE LOCATED IN A JURISDICTION WITH PRIVACY LAWS THAT OFFER
            YOU PRIVACY RIGHTS NOT DESCRIBED IN THIS PRIVACY POLICY, PLEASE
            CONTACT US AT PRIVACY@COCA-COLA.COM. We respect your privacy rights
            and will do our best to accommodate your requests.
          </p>
          <div style={{ marginLeft: "1.2rem" }}>
            <p  style={{marginTop:"1rem"}}>10. HOW DOES COCA-COLA PROTECT CHILDREN''S PRIVACY?</p>
          </div>
          <p  style={{marginTop:"1rem"}}>
            Some of the Services have age restrictions which means that we may
            ask questions to verify your age before we allow you to use those
            Services.
          </p>

          <p  style={{marginTop:"1rem"}}>
            In accordance with our Responsible Marketing Policy, Coca-Cola does
            not direct marketing for our products to children under age 13. If
            you become aware that a child under age 13 or the age set under
            local law has provided us with personal information without parental
            consent or other than as allowed by applicable law, please contact
            our Privacy Office at privacy@coca-cola.com. Once we become aware,
            we will take steps to remove the child’s personal information as
            required by applicable law.
          </p>
          <div style={{ marginLeft: "1.2rem" }}>
            <p  style={{marginTop:"1rem"}}>
              11. DOES COCA-COLA TRANSFER PERSONAL INFORMATION TO OTHER
              COUNTRIES?
            </p>
          </div>
          <p  style={{marginTop:"1rem"}}>
            Coca-Cola may transfer personal information across borders to any of
            the places where we and our suppliers and business partners operate.
            These other places may have data protection laws that are different
            from (and, in some cases, less protective) than the laws where you
            reside.
          </p>
          <p  style={{marginTop:"1rem"}}>
            If your personal information is transferred across borders by us or
            on our behalf, we use appropriate safeguards to protect your
            personal information in accordance with this Privacy Policy and
            applicable law. These safeguards include agreeing to standard
            contractual clauses or model contracts for transfers of personal
            information among the Coca-Cola affiliates and among our suppliers
            and partners. When in place, these contracts require our affiliates,
            suppliers and partners to protect personal information in accordance
            with applicable privacy laws.
          </p>

          <p  style={{marginTop:"1rem"}}>
            To request information about our standard contractual clauses or
            other safeguards for cross-border personal information transfers,
            please contact privacy@coca-cola.com.
          </p>
          <div style={{ marginLeft: "1.2rem" }}>
            <p  style={{marginTop:"1rem"}}>12. WHEN IS THIS PRIVACY POLICY CHANGED?</p>
          </div>
          <p  style={{marginTop:"1rem"}}>
            We may update this Privacy Policy from time to time in response to
            changing legal, technical or business developments. The most current
            version always is available through the Services.
          </p>
          <p  style={{marginTop:"1rem"}}>
            When we update this Privacy Policy, we will post the updated version
            and change the Effective Date above. We also will take appropriate
            measures to inform you in advance of significant changes that we
            believe affect your privacy rights so that you have an opportunity
            to review the revised Privacy Policy before it is effective. If your
            consent is required by applicable privacy laws, we will obtain your
            consent to changes before the revised Privacy Policy applies to you.
            Please regularly check this Privacy Policy to ensure you are aware
            of the updated version.
          </p>
          <div style={{ marginLeft: "1.2rem" }}>
            <p  style={{marginTop:"1rem"}}>13. PRIVACY RIGHTS AND CHOICES</p>
          </div>
          <p  style={{marginTop:"1rem"}}>Residents of India</p>
          <p  style={{marginTop:"1rem"}}>
            The collection and processing of personal data (PD) in India is
            governed by the Information Technology Act, 2000, the Reasonable
            Security Practices and Procedures, the Sensitive Personal Data or
            Information Rules, 2011, and the Digital Personal Data Protection
            Act, 2023 (DPDPA) and its Rules as and when applicable.
          </p>
          <p style={{textDecoration:"underLine"}}>Definitions</p>
          <div style={{ marginLeft: "1.2rem" }}>
            <p  style={{marginTop:"1rem"}}>
              The following definitions are limited to the Residents of India
              section only:
            </p>
            <div>
              <p  style={{marginTop:"1rem"}}>
                . Data Fiduciary: A person or entity who determines the means
                and processing of PD.
              </p>
              <p  style={{marginTop:"1rem"}}>
                . Data Principal: The individual to whom the PD relates to and
                in the case of a person with disability, the Data Principal
                includes their lawful guardian who is acting on their behalf.
              </p>
              <p  style={{marginTop:"1rem"}}>
                . Data Processor: A person or an entity who is processing PD on
                behalf of the Data Fiduciary.
              </p>
              <p  style={{marginTop:"1rem"}}>
                . Personal Data or PD: Any data about an individual who is
                identifiable by or in relation to such data.
              </p>
            </div>
            <p style={{textDecoration:"underLine"}}>Data Fiduciary</p>
            <p  style={{marginTop:"1rem"}}>
              Coca-Cola India Private Limited (CCIPL), a private limited
              company, incorporated under the (Indian) Companies Act, 2013, with
              its registered office at Plot No. 1109-1110, Village Pirangut,
              Taluka Mulshi, Distt is the Data Fiduciary for the services
              provided by it through its various digital assets in India,
              including websites and mobile applications made available by it.
            </p>

            <p style={{textDecoration:"underLine"}}>PD collected by CCIPL</p>
            <p  style={{marginTop:"1rem"}}>
              CCIPL collects PD such as your: (a) name; (b) age; (c) gender; (d)
              internet protocol address; (e) payment information (including
              credit/debit card details, details of other payment methods used,
              other financial data necessary for processing your payment); (f)
              email; (g) telephone number; (h) postal address.
            </p>
            <p  style={{marginTop:"1rem"}}>
              CCIPL does not offer products or services for use by minors and
              does not collect any PD of minors. In providing your information
              to us, you confirm you are aged 18 or above, and not a minor.
            </p>
            <p style={{textDecoration:"underLine"}}>Processing</p>
            <p  style={{marginTop:"1rem"}}>
              CCIPL processes your PD for purposes which may include but are not
              limited to:
            </p>
            <p  style={{marginTop:"1rem"}}>
              (a) Communications. To provide you with the information and
              knowledge in relation to the various products and related services
              of CCIPL and respond to your questions and comments;
            </p>
            <p  style={{marginTop:"1rem"}}>
              (c) Business Purposes. To better serve you by personalizing your
              interactions with the digital assets of CCIPL. We may also use
              your PD for internal business purposes, such as analyzing and
              managing our businesses. The PD you provide may be combined with
              other information you provide to CCIPL (via online or offline
              means), with demographic information and other information that is
              publicly available, or with other information about you that CCIPL
              may otherwise obtain online or offline in a legally compliant
              manner;
            </p>
            <p  style={{marginTop:"1rem"}}>
              (d) Transactions. To facilitate transactions and purchase of
              products on the CCIPL’s website or mobile applications, we may
              collect payment information from you related to such transaction
              as well as other PD such as a shipping address so that we can send
              you the products you have purchased. We may use your PD or payment
              information in order to complete the transaction and, if
              applicable, to fulfill your purchase. We may also provide such
              payment information to third parties as necessary to complete your
              transaction (for example, to process your credit card);
            </p>
            <p  style={{marginTop:"1rem"}}>
              (e) Contests, competitions and other promotions. To provide you
              with details about advertising/marketing campaigns, contests,
              competitions, and other promotions that you choose to participate
              in that may require online registration (which may include name,
              email, user ID and password). We may share this PD with third
              party sponsors of such contests, competitions and promotions
              (irrespective of whether it is hosted by us), or otherwise in
              accordance with the rules applicable to such contest, competition
              or promotion. You should carefully review the rules of each
              contest, competition and promotion in which you participate
              through CCIPL’s website and mobile applications, as they may
              contain additional important information about CCIPL’s or a
              sponsor’s use of your PD. To the extent the terms and conditions
              of such rules concerning the treatment of your PD conflict with
              this Policy, the terms and conditions of such rules shall control;
            </p>
            <p  style={{marginTop:"1rem"}}>
              (f) Special Promotions and Product Information. To provide you
              with updates, personalized recommendations and announcements
              concerning CCIPL’s products and promotions via Email, SMS,
              WhatsApp and/or other communication mediums. You may opt-out of
              receiving these messages from us at any time;
            </p>
            <p  style={{marginTop:"1rem"}}>
              (g) Critical Communications. To relay important information
              regarding CCIPL’s website and mobile applications, user
              transactions, and changes to CCIPL’s terms and conditions or
              policies. Because this information may be critical to your use of
              CCIPL’s website and mobile applications, you may not opt-out of
              receiving these communications sent via emails or other media;
            </p>
            <p  style={{marginTop:"1rem"}}>
              (h) Third Party Service Providers. We work with third parties who
              provide services, including website hosting, credit card
              processing, data analysis, newsletter services, promotional
              activities, and other administrative services. We may share your
              PD, including your payment information, with such third parties
              for the purpose of enabling such third parties to provide such
              services; We may also disclose your PD to select third parties
              including our business associates/partners, advertisers (where
              permitted), and data exchanges. This enables us to provide you
              with personalized content, such as more relevant advertisements
              for products and services that may interest you. These third
              parties may place and access their own cookies, web beacons, and
              similar tracking technologies on your device to deliver customized
              content and advertisements directly to you.
            </p>
            <p  style={{marginTop:"1rem"}}>
              (i) Miscellaneous. To comply with any legal obligations that may
              apply to CCIPL under applicable laws, legal process or government
              requests, to enforce our Terms of Service, to protect our
              operations and the rights, privacy, safety or property of CCIPL,
              and permit CCIPL to pursue available remedies or limit the damages
              it may sustain.
            </p>
            <p  style={{marginTop:"1rem"}}>
              (j) We analyze aggregate information in order to enhance web site
              security, track the popularity of certain pages of the
              websites/apps, the success of our email/other notifications,
              traffic levels and other usage data, all of which helps us to
              provide content tailored to your interests, improve related
              services and to otherwise enhance your experience on the websites
              and mobile applications. We may share this aggregate information
              with other third parties.
            </p>
            <p  style={{marginTop:"1rem"}}>
              The consent provided by you for the processing of your PD will be
              limited to the specified purpose that it was collected for. CCIPL
              ensures that your PD will be retained until you withdraw your
              consent or as soon as it is reasonable to assume that the
              specified purpose is no longer being served, whichever is earlier,
              unless CCIPL is required to retain your PD for a longer period
              under any applicable laws.
            </p>
            <p  style={{textDecoration:"underLine"}}>Disclosure of PD</p>
            <p  style={{marginTop:"1rem"}}>
              CCIPL at any time may engage, appoint, use or otherwise involve a
              Data Processor under a valid contract to process your PD. Hence,
              CCIPL may disclose and transfer your PD to selected third parties.
              Such third parties may provide website hosting, credit card
              processing, data analysis, newsletter services, advertising,
              marketing and promotional activities, and other administrative
              services. Third parties engaged by CCIPL shall use your PD only
              for the purposes agreed upon with CCIPL.
            </p>
            <p  style={{marginTop:"1rem"}}>
              CCIPL may also share your PD with any law enforcement agency,
              regulatory authority or judicial body to comply with a law,
              regulation or compulsory legal request or in connection with an
              investigation, detection or prevention of suspected or actual
              fraudulent or illegal activity.
            </p>
            <p style={{textDecoration:"underLine"}}>Rights of Data Principals</p>
          </div>
          <div>
            <p  style={{marginTop:"1rem"}}>
              Upon the enforcement of the DPDPA, you will have the following
              rights:
            </p>
            <div>
              <p  style={{marginTop:"1rem"}}>. Right to withdraw your consent at any time with ease.</p>
              <p  style={{marginTop:"1rem"}}>. Right to correct, complete, update or erase your PD.</p>
              <p  style={{marginTop:"1rem"}}>
                . Right to seek information on the processing activities and the
                PD being processed.
              </p>
              <p  style={{marginTop:"1rem"}}>
                . Right to seek information on the identities of all the Data
                Processors that your PD has been shared with.
              </p>
              <p  style={{marginTop:"1rem"}}>
                . Right to nominate an individual to exercise your rights on
                your behalf in the event of your death or incapacitation.
              </p>
              <p  style={{marginTop:"1rem"}}>. Right to grievance redressal mechanism.</p>
            </div>
            <p style={{textDecoration:"underLine"}}>Grievance Redressal</p>
          </div>
        </div>
        <div>
          <p  style={{marginTop:"1rem"}}>
            If you have any grievances in relation to the collection, processing, storage, use, disclosure, and transfer of your PD, or would like to discontinue CCIPL’s use of your PD, please contact:
          </p>
          <div style={{marginLeft:"1rem"}}>
            <p  style={{marginTop:"1rem"}}>
              Email Address of the Grievance Officer: gocci@coca-cola.com
            </p>
            <p  style={{marginTop:"1rem"}}>
              Contact number of the Grievance Officer: 1800-208-2653
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  );
};

export default PrivacyAugUpdated;
